import CryptoJS from 'crypto-js';
import baseUrl from "./baseUrl";
const key = CryptoJS.enc.Utf8.parse(baseUrl.TOKEN.slice(-8) + baseUrl.TOKEN.slice(0, 8)); // 密钥
const iv = CryptoJS.enc.Utf8.parse(); // 偏移量
/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word) {
	const srcs = CryptoJS.enc.Utf8.parse(word);
	const encrypted = CryptoJS.AES.encrypt(srcs, key, {
		iv: iv,
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *  */
export function Decrypt(word) {
	const base64 = CryptoJS.enc.Base64.parse(word);
	const src = CryptoJS.enc.Base64.stringify(base64);

	const decrypt = CryptoJS.AES.decrypt(src, key, {
		iv: iv,
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	return CryptoJS.enc.Utf8.stringify(decrypt);
}